import React, { useEffect, useState, useContext } from 'react'
import { Menu, } from 'antd';
import menulist from './menu'
import { StateContext } from './state';
import { Link } from 'react-router-dom';
import {  PullRequestOutlined } from '@ant-design/icons';
import './silder.less'
const { SubMenu } = Menu;
function Sider(props) {

    const [SiderWidth, setSiderWidth] = useState(80)
    const [SelectMenu, setSelectMenu] = useState(["1"]);
    const [menuListFilter, setMenuListFilter] = useState([])
    const { state, dispatch } = useContext(StateContext)
    useEffect(() => {
        var path = window.location.hash
        let temp_menulist = menulist.filter(item => {return{...item}})
        if (props.userType!==104){
            temp_menulist[1].child = temp_menulist[1].child.filter(item=>item.name!=='订单管理')
        }else{
            if(props.userRole?.includes('306')&& !temp_menulist[1].child.includes('订单管理') )
            temp_menulist[1].child.push({
                name: '订单管理',
                key: '2-7',
                auth: false,
                local: false,
                soc: true,
                role: '306',
                u_type: 104,
                icon: <PullRequestOutlined />,
                path: '/monitor/trans'
            })
        }
        setMenuListFilter(temp_menulist)
        for (var i = 0; i < temp_menulist.length; i++) {

            if ('#' + temp_menulist[i].path === path) {
                setSelectMenu([temp_menulist[i].key])
                break
            }
            if (temp_menulist[i].child) {
                for (var j = 0; j < temp_menulist[i].child.length; j++) {
                    if ('#' + temp_menulist[i].child[j].path === path) {
                        setSelectMenu([temp_menulist[i].key])
                        break
                    }
                }
            }
        }

       
        
    }, [])
    return (
        <div style={{ transition: 'width .25s linear',  width: SiderWidth,  }} className="leftNav">
            <div style={{ height: 44 ,fontSize:22,color:'#fff' ,textAlign:'center',cursor:'pointer'}}onClick={() => {
                let temp = document.getElementsByClassName('hisshow');
                if (SiderWidth === 200) {
                    setSiderWidth(80);
                    if (temp.length>0){
                        let list = Array.from(temp);
                        list.map(item=>{
                            let name = item.className;
                            if (name.indexOf('tableshow1')===-1){
                                name = name+'1';
                                item.className = name;
                            } 
                        })
                        
                    }
                } else {
                    setSiderWidth(200);
                    if (temp.length>0){
                        let list = Array.from(temp);
                        list.map(item=>{
                            let name = item.className;
                            if (name.indexOf('tableshow1')!==-1){
                                name = name.slice(0,-1);
                                item.className = name;
                            }
                        })
                        
                    }
                }
            }}>
                
                {
                    SiderWidth === 200 ?'<':'>'
                }
            </div>
            {/* <div style={{ flex: 1 }}> */}
            <Menu theme='dark' defaultSelectedKeys={SelectMenu}   mode="inline"  inlineCollapsed={SiderWidth !== 200} onClick={e=>{
                // sessionStorage.setItem('reload',false)  
            state.runningtime=0;
             dispatch({type:'runningtime',runningtime:state.runningtime})}} >
                {
                    menuListFilter.map((item, index) => { return(
                        item.u_type >= state.main.type && (item.child ?
                            <SubMenu key={item.key} icon={item.icon} title={item.name}>
                                {
                                    item.child.map((citem, cindex) => {
                                     return (
                                        (!citem.auth || (citem.auth && state.main.type === 101)) && (citem.soc||(state.main.type===105&&citem.local)) && citem.u_type >= state.main.type 
                                        && state.main.role.indexOf(citem.role)>-1
                                        && (
                                            <Menu.Item key={citem.key} icon={citem.icon} >
                                                <Link to={citem.path}>{citem.name}</Link>
                                            </Menu.Item>
                                        ) 
                                    )})
                                }
                            </SubMenu> :
                            <Menu.Item key={item.key} icon={item.icon}><Link to={item.path}>{item.name}</Link></Menu.Item>)

                    )})
                }
            </Menu>
            {/* </div> */}
            {/* <div onClick={() => { setSiderWidth(SiderWidth === 200 ? 80 : 200) }} style={{ height: 48, backgroundColor: '#001529', textAlign: 'center', padding: 12, cursor: 'pointer' }}>
                {
                    SiderWidth === 200 ?
                        <DoubleLeft theme="outline" size="24" fill="#fff" /> :
                        <DoubleRight theme="outline" size="24" fill="#fff" />
                }
            </div> */}
        </div>
    )
}

export default Sider